/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Orders_Tracking_Audit_AtInputs */

const en_orders_tracking_audit_at = /** @type {(inputs: Orders_Tracking_Audit_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Set on ${i?.date}`)
};

const es_orders_tracking_audit_at = /** @type {(inputs: Orders_Tracking_Audit_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Establecido el ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Set on {date}" |
*
* @param {Orders_Tracking_Audit_AtInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_tracking_audit_at = /** @type {((inputs: Orders_Tracking_Audit_AtInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Tracking_Audit_AtInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_tracking_audit_at(inputs)
	return es_orders_tracking_audit_at(inputs)
});